import { AcceptedActions, IState } from "./interfaces";
import { createAction, createActionPayload } from "../common/actions";
import { User, UserMinified } from "../services/generated-sdk/models";

const ACTION_SET_SET_USERS = "ACTION_SET_USERS";
const ACTION_SET_DELETED_USERS = "ACTION_SET_DELETED_USERS";
const ACTION_SET_INITIAL_FETCH = "ACTION_SET_INITIAL_FETCH";
const ACTION_SET_PAGE_TITLE = "ACTION_SET_PAGE_TITLE";
const ACTION_SET_SHOW_CACHE_REFRESH_MODAL =
  "ACTION_SET_SHOW_CACHE_REFRESH_MODAL";
const ACTION_SET_IGNORE_CACHE_CHECK = "ACTION_SET_IGNORE_CACHE_CHECK";
const ACTION_SET_META_JSON_BUILD_ID = "ACTION_SET_META_JSON_BUILD_ID";

export const Actions = {
  setUsers: createActionPayload<typeof ACTION_SET_SET_USERS, Array<User>>(
    ACTION_SET_SET_USERS
  ),
  setDeletedUsers: createActionPayload<
    typeof ACTION_SET_DELETED_USERS,
    Array<UserMinified>
  >(ACTION_SET_DELETED_USERS),
  setInitiallyFetched: createAction<typeof ACTION_SET_INITIAL_FETCH>(
    ACTION_SET_INITIAL_FETCH
  ),
  setPageTitle: createActionPayload<typeof ACTION_SET_PAGE_TITLE, string>(
    ACTION_SET_PAGE_TITLE
  ),
  setShowCacheRefreshModal: createActionPayload<
    typeof ACTION_SET_SHOW_CACHE_REFRESH_MODAL,
    boolean
  >(ACTION_SET_SHOW_CACHE_REFRESH_MODAL),
  setIgnoreCacheCheck: createActionPayload<
    typeof ACTION_SET_IGNORE_CACHE_CHECK,
    any
  >(ACTION_SET_IGNORE_CACHE_CHECK),
  setMetaJsonBuildId: createActionPayload<
    typeof ACTION_SET_META_JSON_BUILD_ID,
    string
  >(ACTION_SET_META_JSON_BUILD_ID)
};

export function reducer(state: IState, action: AcceptedActions): IState {
  switch (action.type) {
    case ACTION_SET_SET_USERS:
      return { ...state, users: action.payload };
    case ACTION_SET_DELETED_USERS:
      return { ...state, deletedUsers: action.payload };
    case ACTION_SET_PAGE_TITLE:
      return { ...state, pageTitle: action.payload };
    case ACTION_SET_SHOW_CACHE_REFRESH_MODAL:
      return { ...state, showCacheRefreshModal: action.payload };
    case ACTION_SET_IGNORE_CACHE_CHECK:
      return { ...state, ignoreCacheCheck: action.payload };
    case ACTION_SET_META_JSON_BUILD_ID:
      return { ...state, metaJsonBuildId: action.payload };
    case ACTION_SET_INITIAL_FETCH:
      return { ...state, initialFetch: false };
    default:
      return state;
  }
}
